import { useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';

const useIsMobile = () => {
    const theme = useTheme();
    const [isMobile] = useState<boolean>(!useMediaQuery(theme.breakpoints.up('sm')));
    const isTest = process.env.JEST_WORKER_ID !== undefined;
    return isMobile && !isTest;
};

export default useIsMobile;
